import { keyframes } from '@emotion/react';

// AUCUNE animation `infinite` : une boucle perpétuelle attire l'oeil en permanence
// et se remarque surtout sur un écran qu'on garde ouvert. Tout se joue une ou deux fois.
// Les durées passent systématiquement par useDurees().d(), qui renvoie 0 sous
// prefers-reduced-motion ; ces keyframes ne sont alors jamais montées.

/** Pastille d'étape qui vient d'être validée. */
export const pastilleOk = keyframes`
  0%   { transform: scale(0.6); opacity: 0; }
  60%  { transform: scale(1.12); opacity: 1; }
  100% { transform: scale(1); opacity: 1; }
`;

/** Appel à l'action de l'étape courante : deux pulsations, puis plus rien. */
export const pulseCTA = keyframes`
  0%   { box-shadow: 0 0 0 0 rgba(46,125,50,0.45); }
  70%  { box-shadow: 0 0 0 10px rgba(46,125,50,0); }
  100% { box-shadow: 0 0 0 0 rgba(46,125,50,0); }
`;

/** Anneau de la célébration. */
export const pulseAnneau = keyframes`
  0%   { transform: scale(1); opacity: 0.5; }
  100% { transform: scale(2.1); opacity: 0; }
`;

/** Confetti unique. La rotation évite l'effet « pluie de rectangles ». */
export const chuteConfetti = keyframes`
  0%   { transform: translateY(-16px) rotate(0deg); opacity: 1; }
  100% { transform: translateY(170px) rotate(520deg); opacity: 0; }
`;
